var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("places-and-directions", {
        attrs: {
          active: _vm.$store.getters.mode !== _vm.constants.modes.isochrones
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f562f66a", { render: render, staticRenderFns: staticRenderFns })
  }
}